import type { FC } from "react";

import type { BuilderBlock } from "@builder.io/sdk-react";
import { isEditing } from "@builder.io/sdk-react";

import type { EditingZone } from "@/components/Footer/Footer";
import { EditableZone } from "@/libs/builder/Blocks";
import { useDisplayModelComponent } from "@/libs/builder/hooks/useDisplayModelComponent";

type FooterClientEditingZoneProps = {
  editingZone?: EditingZone;
  propPath: string;
  parentId?: string;
};

export const FooterClientEditingZone: FC<FooterClientEditingZoneProps> = ({ editingZone, propPath, parentId }) => {
  const shouldDisplayModelComponent = useDisplayModelComponent("footer");
  const shouldRender = Boolean(editingZone?.length) || (isEditing() && shouldDisplayModelComponent);
  if (!shouldRender) return null;

  return <EditableZone parent={parentId} blocks={editingZone as BuilderBlock[]} blockPropPathSegments={propPath} />;
};
